export default __webpack_public_path__ + "static/media/next-icon.cdb5d46d.svg";